import React from 'react';

const Table = ({ data }) => {
  // Function to process data and add a TOTAL row
  const processData = (data1, data2) => {
    const combinedData = {};
  
    data1.forEach(item => {
      combinedData[item.label] = { col1: item.percentage, col2: '-' };
    });
  
    data2.forEach(item => {
      if (combinedData[item.label]) {
        combinedData[item.label].col2 = item.percentage;
      } else {
        combinedData[item.label] = { col1: '-', col2: item.percentage };
      }
    });

    // Convert combined data into an array of objects
    const processedData = Object.keys(combinedData).map(label => ({
      label,
      ...combinedData[label],
    }));

    // Add TOTAL row at the end
    processedData.push({ label: 'TOTAL', col1: '100', col2: '100' });

    return processedData;
  };

  const processedData = processData(data[0] || [], data[1] || []);

  return (
    <div className="grid-container">
      <div className="grid-item merged-vertical">Waste Fractions</div>
      <div className="grid-item merged-horizontal">Percentage Fraction (%)</div>
      <div className="grid-item color-highlight">{data[0]?.[0]?.year || 'N/A'} (WMD)</div>
      <div className="grid-item color-highlight">{data[1]?.[0]?.year || 'N/A'} (WMD)</div>

      {processedData.map((item, index) => (
        <React.Fragment key={index}>
          <div className={`grid-item ${index === processedData.length - 1 ? 'last-row' : 'non-colored'}`}>
            {item.label}
          </div>
          <div className={`grid-item ${index === processedData.length - 1 ? 'last-row' : 'non-colored'}`}>
            {item.col1}
          </div>
          <div className={`grid-item ${index === processedData.length - 1 ? 'last-row' : 'non-colored'}`}>
            {item.col2}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default Table;
